import * as React from "react";
import "../filters.scss";
import RadioButton, {IRadioButton} from "../../../../hiberUiKit/src/atoms/Buttons/RadioButton";
import {none, option, Option} from "ts-option";
import {NumberFilterType, NumberFilterTypeName} from "./NumberFilter";
import NumberFilterModel from "../../../../model/workspace/NumberFilterModel";
import NumberUtils from "../../../../utils/NumberUtils";

interface IProps {
	/**
	 * Input value
	 */
	value: Option<NumberBetweenFilterModel>
	/**
	 * On change callback
	 * @param {Option<NumberBetweenFilterModel>} value
	 */
	onChange: (value: Option<NumberBetweenFilterModel>) => void
	/**
	 * Selected radio button Id
	 */
	selectedRadioButtonId: string
	/**
	 * On select button
	 * @param {string} id
	 */
	onSelectButton: (id: string) => void
}

interface IState {
	/**
	 * Minimum number of "Between" range.
	 */
	from: Option<number>;
	/**
	 * Maximum number of "Between" range.
	 */
	to: Option<number>;
}

export default class NumberBetweenFilter extends React.Component<IProps, IState> {
	radioButton: IRadioButton = {
		label: NumberFilterTypeName[NumberFilterType.Between],
		disabled: false,
		value: NumberFilterType.Between
	};

	constructor(props: IProps) {
		super(props);
		this.state = {
			from: props.value.map(v => v.from),
			to: props.value.map(v => v.to)
		};
		this.onFromChange = this.onFromChange.bind(this);
		this.onToChange = this.onToChange.bind(this);
		this.resetFilter = this.resetFilter.bind(this);
	}

	componentWillReceiveProps(nextProps: IProps) {
		if (this.props.selectedRadioButtonId === this.radioButton.value &&
			nextProps.selectedRadioButtonId !== this.radioButton.value) {
			this.resetFilter();
		}
	}

	render() {
		const radioButtonChecked = (this.props.selectedRadioButtonId === this.radioButton.value);
		return (
			<div className={"c-filter-dates_inputs_row"}>
				<RadioButton radioButton={this.radioButton}
							 onChange={() => this.props.onSelectButton(this.radioButton.value)}
							 checked={radioButtonChecked}/>
				<input className="c-filter_numbers_input between"
					   type="number"
					   value={this.state.from.getOrElse(undefined)}
					   onChange={this.onFromChange}
					   disabled={!radioButtonChecked}/>
				<label className={"t-body c-filter-dates_inputs_row_label"}>and</label>
				<input className="c-filter_numbers_input"
					   type="number"
					   value={this.state.to.getOrElse(undefined)}
					   onChange={this.onToChange}
					   disabled={!radioButtonChecked}/>
			</div>
		);
	}

	/**
	 * Callback on change input.
	 */
	onFromChange = (e: React.FormEvent<HTMLInputElement>) => {
		const value = e.currentTarget.value;
		if (value.length === 0) {
			this.setState({from: none});
		}
		else if (NumberUtils.isNumber(value)) {
			const valueAsNumber = Number(value);
			this.setState({from: option(valueAsNumber)}, this.onChangeCallback);
		}
	};

	/**
	 * Callback on change input.
	 */
	onToChange = (e: React.FormEvent<HTMLInputElement>) => {
		const value = e.currentTarget.value;
		if (value.length === 0) {
			this.setState({to: none});
		}
		else if (NumberUtils.isNumber(value)) {
			const valueAsNumber = Number(value);
			this.setState({to: option(valueAsNumber)}, this.onChangeCallback);
		}
	};

	onChangeCallback() {
		if (this.state.from.isDefined && this.state.to.isDefined && this.state.from.get <= this.state.to.get) {
			this.props.onChange(option(new NumberBetweenFilterModel(this.state.from.get, this.state.to.get)));
		}
		else {
			this.props.onChange(none);
		}
	}

	/**
	 * Reset filter
	 */
	resetFilter() {
		this.setState({from: none, to: none});
	}
}

export class NumberBetweenFilterModel extends NumberFilterModel {
	constructor(public readonly from: number,
		public readonly to: number) {
		super(NumberFilterType.Between);
	}

	static fromJson(json: number[]) {
		return new NumberBetweenFilterModel(json[0], json[1]);
	}

	getDisplayValue(): string {
		return `${super.getDisplayValue()} ${this.from} - ${this.to}`;
	}

	toQueryJson() {
		return [this.from, this.to];
	}
}
